import { PackageCarrier, PackageCarrierSchema } from '@/models'

export const CARRIER_LOGO_MAP: Record<PackageCarrier, string | null> = {
  [PackageCarrierSchema.enum.amazon]: '/images/package-room/amazon.svg',
  [PackageCarrierSchema.enum.dhl]: '/images/package-room/dhl.svg',
  [PackageCarrierSchema.enum.fedex]: '/images/package-room/fedex.svg',
  [PackageCarrierSchema.enum.other]: null,
  [PackageCarrierSchema.enum.ups]: '/images/package-room/ups.svg',
  [PackageCarrierSchema.enum.usps]: '/images/package-room/usps-small.svg',
}
